<template>
  <form
    class="mt-8 max-w-[680px] bg-white p-6"
    @submit.prevent="sendData"
  >
    <div class="flex flex-col gap-2">
      <label
        for="title"
        class="text-sm font-semibold text-gray-900"
      >Tier title</label>
      <input
        id="title"
        v-model="tier_title"
        type="text"
        class="w-full border border-gray-300 px-4 py-2 text-gray-700 outline-none focus:border-transparent focus:ring-1 focus:ring-green-400"
      >
    </div>
    <div class="mt-6 flex flex-wrap items-center justify-start gap-4">
      <div class="flex flex-col gap-2">
        <label
          for="multiple_companies"
          class="text-sm font-semibold text-gray-900"
        >Companies</label>
        <input
          id="multiple_companies"
          v-model="tier_multiple_companies"
          type="text"
          class="w-[200px] border border-gray-300 px-4 py-2 text-gray-700 outline-none focus:border-transparent focus:ring-1 focus:ring-green-400"
        >
      </div>
      <div class="flex flex-col gap-2">
        <label
          for="sources"
          class="text-sm font-semibold text-gray-900"
        >Sources</label>
        <input
          id="sources"
          v-model="tier_sources"
          type="text"
          class="w-[200px] border border-gray-300 px-4 py-2 text-gray-700 outline-none focus:border-transparent focus:ring-1 focus:ring-green-400"
        >
      </div>
      <div class="flex flex-col gap-2">
        <label
          for="locations"
          class="text-sm font-semibold text-gray-900"
        >Locations</label>
        <input
          id="locations"
          v-model="tier_locations"
          type="text"
          class="w-[200px] border border-gray-300 px-4 py-2 text-gray-700 outline-none focus:border-transparent focus:ring-1 focus:ring-green-400"
        >
      </div>
    </div>
    <div class="mt-6 flex flex-wrap items-center justify-start gap-4">
      <div class="flex flex-col gap-2">
        <label
          for="labels"
          class="text-sm font-semibold text-gray-900"
        >Labels</label>
        <select
          id="labels"
          v-model="tier_labels"
          class="w-[200px] border border-gray-300 px-4 py-2 text-gray-700 outline-none focus:border-transparent focus:ring-1 focus:ring-green-400"
          @change="tier_labels = $event.target.value"
        >
          <option value="1">
            Yes
          </option>
          <option value="0">
            No
          </option>
        </select>
      </div>
      <div class="flex flex-col gap-2">
        <label
          for="pollutants"
          class="text-sm font-semibold text-gray-900"
        >Pollutants</label>
        <select
          id="pollutants"
          v-model="tier_pollutants"
          class="w-[200px] border border-gray-300 px-4 py-2 text-gray-700 outline-none focus:border-transparent focus:ring-1 focus:ring-green-400"
          @change="tier_pollutants = $event.target.value"
        >
          <option value="standard 6">
            Standard 6
          </option>
          <option value="custom">
            Custom
          </option>
        </select>
      </div>
      <div class="flex flex-col gap-2">
        <label
          for="manual_entry"
          class="text-sm font-semibold text-gray-900"
        >Manual Entry</label>
        <select
          id="manual_entry"
          v-model="tier_manual_entry"
          class="w-[200px] border border-gray-300 px-4 py-2 text-gray-700 outline-none focus:border-transparent focus:ring-1 focus:ring-green-400"
          @change="tier_manual_entry = $event.target.value"
        >
          <option value="1">
            Yes
          </option>
          <option value="0">
            No
          </option>
        </select>
      </div>
    </div>
    <div class="mt-6 flex flex-wrap items-center justify-start gap-4">
      <div class="flex flex-col gap-2">
        <label
          for="bulk_upload"
          class="text-sm font-semibold text-gray-900"
        >Bulk Upload</label>
        <select
          id="bulk_upload"
          v-model="tier_bulk_upload"
          class="w-[200px] border border-gray-300 px-4 py-2 text-gray-700 outline-none focus:border-transparent focus:ring-1 focus:ring-green-400"
          @change="tier_bulk_upload = $event.target.value"
        >
          <option value="1">
            Yes
          </option>
          <option value="0">
            No
          </option>
        </select>
      </div>
      <div class="flex flex-col gap-2">
        <label
          for="integrations"
          class="text-sm font-semibold text-gray-900"
        >Integrations</label>
        <select
          id="integrations"
          v-model="tier_integrations"
          class="w-[200px] border border-gray-300 px-4 py-2 text-gray-700 outline-none focus:border-transparent focus:ring-1 focus:ring-green-400"
          @change="tier_integrations = $event.target.value"
        >
          <option value="0">
            0
          </option>
          <option value="less than 10">
            Less than 10
          </option>
          <option value="less than 100">
            Less than 100
          </option>
          <option value="less than 1000">
            Less than 1000
          </option>
        </select>
      </div>
      <div class="flex flex-col gap-2">
        <label
          for="audit_log"
          class="text-sm font-semibold text-gray-900"
        >Audit Log</label>
        <select
          id="audit_log"
          v-model="tier_audit_log"
          class="w-[200px] border border-gray-300 px-4 py-2 text-gray-700 outline-none focus:border-transparent focus:ring-1 focus:ring-green-400"
          @change="tier_audit_log = $event.target.value"
        >
          <option value="1">
            Yes
          </option>
          <option value="0">
            No
          </option>
        </select>
      </div>
    </div>
    <div class="mt-6 flex flex-col gap-2">
      <label
        for="disclosure_reports"
        class="text-sm font-semibold text-gray-900"
      >Disclosure Reports</label>
      <select
        id="disclosure_reports"
        v-model="tier_disclosure_reports"
        class="w-[200px] border border-gray-300 px-4 py-2 text-gray-700 outline-none focus:border-transparent focus:ring-1 focus:ring-green-400"
        @change="tier_disclosure_reports = $event.target.value"
      >
        <option value="1">
          Yes
        </option>
        <option value="0">
          No
        </option>
        <option value="limited (1 Report)">
          Limited (1 Report)
        </option>
      </select>
    </div>
    <button
      type="submit"
      class="mt-10 rounded bg-zuno-turquoise px-4 py-2 text-sm capitalize text-slate-50 hover:bg-zuno-turquoise/80 disabled:cursor-not-allowed disabled:bg-zuno-turquoise/70"
      :disabled="cantSubmitTier"
    >
      {{ buttonText }}
    </button>
  </form>
</template>

<script>
export default {
  name: 'TierForm',

  props: {
    tierData: {
      type: Object,
      default: () => {
        return {
          title: '',
          multiple_companies: '',
          sources: '',
          locations: '',
          labels: 0,
          pollutants: 'standard 6',
          manual_entry: 0,
          bulk_upload: 0,
          audit_log: 0,
          integrations: 'less than 1000',
          disclosure_reports: '1',
        }
      },
    },
    buttonText: {
      type: String,
      default: 'submit',
    },
  },

  emits: ['formDataSubmitted'],

  data() {
    return {
      tier_title: this.tierData.title,
      tier_multiple_companies: this.tierData.multiple_companies,
      tier_sources: this.tierData.sources,
      tier_locations: this.tierData.locations,
      tier_labels: this.tierData.labels,
      tier_pollutants: this.tierData.pollutants,
      tier_manual_entry: this.tierData.manual_entry,
      tier_bulk_upload: this.tierData.bulk_upload,
      tier_audit_log: this.tierData.audit_log,
      tier_integrations: this.tierData.integrations,
      tier_disclosure_reports: this.tierData.disclosure_reports,
    }
  },

  computed: {
    cantSubmitTier() {
      return (
        !this.tier_title
        || !this.tier_multiple_companies
        || !this.tier_sources
        || !this.tier_locations
      )
    },
  },

  methods: {
    sendData() {
      this.$emit('formDataSubmitted', {
        title: this.tier_title,
        multiple_companies: this.tier_multiple_companies,
        locations: this.tier_locations,
        sources: this.tier_sources,
        labels: Boolean(Number(this.tier_labels)),
        pollutants: this.tier_pollutants,
        manual_entry: Boolean(Number(this.tier_manual_entry)),
        bulk_upload: Boolean(Number(this.tier_bulk_upload)),
        integrations: this.tier_integrations,
        audit_log: Boolean(Number(this.tier_audit_log)),
        disclosure_reports: this.tier_disclosure_reports,
      })
    },
  },
}
</script>
